<template>
    <div>
        <div class="app-topnav" :class="$auth.isSubdomainActive() ? 'app-topnav--subdomain' : ''">
            <div v-show="!isSearchClicked && !$auth.isSubdomainActive()" class="app-topnav__mobile-menu">
                <div class="app-topnav__mobile-nav" @click.stop="emitEvent({ name: 'open-sidenav' })">
                    <common-icon name="mobile-nav" size="extra-huge"></common-icon>
                </div>

                <div v-if="!$auth.isUserAdmin()" class="app-topnav__offer">
                    <common-button
                        type="quaternary"
                        icon="plus-circle"
                        size="tiny"
                        :isSubmittable="false"
                        :label="plusButtonLabel"
                        @click="goToCreateOfferPage()"
                    ></common-button>
                    <common-dropdown
                        v-click-away="closeCreateOfferDropdown"
                        :isOpen="isCreateOfferDropdown"
                        :recalculatePosition="false"
                        arrowPositionY="top"
                        arrowPositionX="left"
                        class="app-topnav__offer-dropdown"
                    >
                        <div class="app-topnav__offer-dropdown__menu">
                            <div class="app-topnav__offer-dropdown__menu--item" type="button" @click="userCreateOffer()">
                                <common-icon name="user-solid" size="huge"></common-icon>
                                <div class="app-topnav__offer-dropdown__menu--item-title">
                                    {{ $t('layouts.app.top_menu.create_user_offer') }}
                                </div>
                            </div>
                            <hr />
                            <div
                                class="app-topnav__offer-dropdown__menu--item"
                                type="button"
                                @click="toggleSelectCompanyModalOpen()"
                            >
                                <common-icon name="user-tie" size="huge"></common-icon>
                                <div class="app-topnav__offer-dropdown__menu--item-title">
                                    {{ $t('layouts.app.top_menu.create_company_offer') }}
                                </div>
                            </div>
                        </div>
                    </common-dropdown>
                </div>
            </div>

            <button v-show="isSearchClicked && !$auth.isSubdomainActive()" class="app-topnav__btn" @click="hideSearch">
                <common-icon name="back" size="huge"></common-icon>
            </button>
            <div v-show="showSearchBar && !$auth.isSubdomainActive() && !$auth.isUserAdmin()" class="app-topnav__search">
                <common-search-autocomplete
                    ref="searchAutocomplete"
                    :placeholder="$t('layouts.app.top_menu.find_offers')"
                    :searchApi="searchAutocompleteApi"
                    @enter-click="activateSearch($event)"
                    @search-change="searchChange"
                    @search-results-change="updateSearchResults"
                >
                    <category-autocomplete-options
                        ref="autocompleteOptions"
                        :searchTerm="searchTerm"
                        :options="searchResults"
                        @filter-selected="hideSearchResults"
                    ></category-autocomplete-options>
                </common-search-autocomplete>
            </div>

            <div v-show="!isSearchClicked" class="app-topnav__user-menu">
                <locale-select></locale-select>
                <button
                    v-show="!showSearchBar"
                    class="app-topnav__search-btn app-topnav__search-btn app-topnav__btn"
                    @click="showSearch"
                >
                    <common-icon name="search" size="extra-huge"></common-icon>
                </button>
                <app-user-menu v-if="isUserLoggedIn"></app-user-menu>
                <common-button
                    v-else
                    type="secondary"
                    :label="$t('layouts.app.top_menu.login')"
                    :route="{ name: RoutesEnum.AUTH.LOGIN }"
                    :size="buttonSize"
                ></common-button>
            </div>
        </div>

        <create-company-modal
            v-if="isCreateCompanyModalOpen"
            @close="closeCreateCompanyModal"
            @success="closeCreateCompanyModal"
        ></create-company-modal>
        <select-location-modal
            v-if="isSelectLocationModalOpen"
            :locations="selectLocationOptions"
            @close="closeSelectLocation()"
            @location-selected="createOffer($event)"
            @open-location-tab="openLocationTab()"
        ></select-location-modal>
        <select-company-modal
            v-if="isSelectCompanyModalOpen"
            :companies="companyOptions"
            @close="closeSelectCompany()"
            @company-selected="companySelected($event)"
            @create-company="createCompany()"
        ></select-company-modal>
        <profile-not-completed-modal
            :isModalOpen="isProfileNotCompletedModalOpen"
            @close-complete-profile-modal="closeProfileNotCompletedModal"
        ></profile-not-completed-modal>
        <please-register-modal v-if="isPleaseRegisterModalOpen" @close="closePleaseRegisterModal"></please-register-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Store from '@/store'
    import AppUserMenu from 'components/layouts/components/main-layout/AppUserMenu'
    import CreateCompanyModal from 'components/modals/company/CreateCompanyModal'
    import LocaleSelect from 'components/page-elements/localization/LocaleSelect'
    import CategoryAutocompleteOptions from 'components/page-elements/offer/CategoryAutocompleteOptions'
    import RoutesEnum from 'enums/routes.enum'
    import OfferAPI from 'api/OfferAPI'
    import WindowResizeMixin from 'mixins/WindowResizeMixin'
    import PleaseRegisterModal from 'components/modals/PleaseRegisterModal'
    import SelectLocationModal from 'components/modals/offer/SelectLocationModal'
    import SelectCompanyModal from 'components/modals/company/SelectCompanyModal'
    import ProfileNotCompletedModal from 'components/modals/user/ProfileNotCompletedModal'
    import LocationTypeEnum from 'enums/location_type.enum'

    export default {
        mixins: [WindowResizeMixin],

        components: {
            AppUserMenu,
            CreateCompanyModal,
            LocaleSelect,
            CategoryAutocompleteOptions,
            PleaseRegisterModal,
            SelectLocationModal,
            SelectCompanyModal,
            ProfileNotCompletedModal,
        },

        data() {
            return {
                selectLocationOptions: [],
                RoutesEnum,
                isAddDropdownOpen: false,
                isCreateOfferDropdown: false,
                isCreateCompanyModalOpen: false,
                searchAutocompleteApi: OfferAPI.findOfferCategoriesByTerm,
                searchResults: [],
                isSearchClicked: false,
                searchTerm: '',
                isProfileNotCompletedModalOpen: false,
                isPleaseRegisterModalOpen: false,
                isSelectLocationModalOpen: false,
                isSelectCompanyModalOpen: false,
                selectedCompany: {},
                LocationTypeEnum: LocationTypeEnum,
            }
        },

        computed: {
            ...mapGetters({
                isFilterModalOpen: 'configuration/getIsFilterModalOpen',
            }),

            isUserLoggedIn() {
                return this.$auth.isLoggedIn()
            },

            showSearchBar() {
                return !this.isTabletSmall || this.isSearchClicked
            },

            buttonSize() {
                return this.isSmartphoneLarge ? 'small' : 'medium-small'
            },

            plusButtonLabel() {
                return this.isTabletSmall ? '' : this.$t('layouts.app.top_menu.create_service')
            },
            companyOptions() {
                return this.$auth.getUser()?.companyUsers.map((companyUser) => ({
                    id: companyUser.company.id,
                    name: companyUser.company.name,
                    locationsForCompany: companyUser.company.locationsForCompany,
                }))
            },
        },

        methods: {
            companySelected(company) {
                this.selectedCompany = company
                this.selectLocationOptions = company.locationsForCompany.filter(
                    (location) => location.locationType === LocationTypeEnum.BUSINESS,
                )
                this.toggleSelectLocationModal()
                this.closeSelectCompany()
            },
            createCompany() {
                this.$router.push({ name: RoutesEnum.COMPANY.CREATE })
                this.closeSelectCompany()
                this.closeCreateOfferDropdown()
            },
            toggleSelectCompanyModalOpen() {
                this.isSelectCompanyModalOpen = !this.isSelectCompanyModalOpen
            },
            closeSelectCompany() {
                this.isSelectCompanyModalOpen = false
                this.closeCreateOfferDropdown()
            },
            userCreateOffer() {
                this.selectLocationOptions = this.$auth
                    .getUser()
                    ?.locationsForUser.filter((location) => location.locationType === LocationTypeEnum.BUSINESS)
                this.toggleSelectLocationModal()
            },
            createOffer(location) {
                const query = {
                    location: location.id,
                }
                if (this.selectedCompany) {
                    query.company = this.selectedCompany.id
                }

                this.$router.push({ name: RoutesEnum.OFFER.CREATE, query: query })

                this.toggleSelectLocationModal()
                this.closeSelectLocation()
            },
            openLocationTab() {
                if (this.selectedCompany?.id) {
                    this.$router.push({
                        name: RoutesEnum.COMPANY.MY_COMPANY,
                        params: { id: this.selectedCompany?.id, tabType: 'profile' },
                        query: { tab: 'locations' },
                    })
                } else {
                    this.$router.push({ name: RoutesEnum.USER.ME, params: { tabType: 'locations' }, query: { tab: 'locations' } })
                }
                this.closeSelectLocation()
            },
            closeSelectLocation() {
                this.closeSelectLocationModal()
                this.selectLocationOptions = []
                this.selectedCompany = {}
                this.closeCreateOfferDropdown()
                this.closeSelectCompany()
            },
            toggleSelectLocationModal() {
                this.isSelectLocationModalOpen = !this.isSelectLocationModalOpen
            },
            closeSelectLocationModal() {
                this.isSelectLocationModalOpen = false
            },
            toggleCreateOfferDropdown() {
                this.isCreateOfferDropdown = !this.isCreateOfferDropdown
            },
            closeCreateOfferDropdown() {
                this.isCreateOfferDropdown = false
            },
            openAddDropdown() {
                this.isAddDropdownOpen = !this.isAddDropdownOpen
            },

            closeProfileNotCompletedModal() {
                this.isProfileNotCompletedModalOpen = false
            },

            closeAddDropdown() {
                this.isAddDropdownOpen = false
            },

            closeCreateCompanyModal() {
                this.isCreateCompanyModalOpen = false
            },

            goToCreateOfferPage() {
                if (!this.$auth.getUser()?.id) {
                    this.isPleaseRegisterModalOpen = true
                    return
                }
                if (!this.$auth.isUserCompleteProfile()) {
                    this.isProfileNotCompletedModalOpen = true
                    return
                }
                this.toggleCreateOfferDropdown()
            },

            goToFindOfferPage() {
                this.closeAddDropdown()
                this.$router.push({ name: RoutesEnum.OFFER.FIND })
            },

            updateSearchResults(results) {
                this.searchResults = results
            },

            searchChange(term) {
                this.searchTerm = term
            },

            hideSearchResults() {
                this.$refs.searchAutocomplete.hideResults()
            },

            showSearch() {
                this.isSearchClicked = true
            },

            hideSearch() {
                this.isSearchClicked = false
            },

            activateSearch(event) {
                const searchTerm = this.searchTerm?.trim()
                const searchTermValue = searchTerm ? searchTerm : undefined

                let query = {
                    ...this.$route.query,
                    filter: searchTermValue,
                }
                if (event) {
                    query = {
                        ...event,
                        filter: searchTermValue,
                        orderBy: this.$route.query.orderBy,
                        wayDefinition: this.$route.query.wayDefinition,
                    }
                }
                if (this.$route.name !== RoutesEnum.OFFER.FIND) {
                    if (!query.countryId) {
                        query.countryId = Store.getters['data/getCountryByGeolocation']
                    }
                }

                this.$refs.searchAutocomplete.value = searchTerm
                this.$router.push({ name: RoutesEnum.OFFER.FIND, query })
            },
            closePleaseRegisterModal() {
                this.isPleaseRegisterModalOpen = false
            },
            prefillSearchValue() {
                const searchTerm = this.$route.query.filter
                if (searchTerm) {
                    this.searchTerm = searchTerm
                }
            },
        },

        watch: {
            '$route.query'() {
                this.searchTerm = this.$route.query?.filter
            },

            isFilterModalOpen() {
                if (this.isFilterModalOpen) {
                    if (!this.showSearchBar) {
                        this.showSearch()
                    }
                    this.$refs.searchAutocomplete.togleSearchDropdown()
                    Store.dispatch('configuration/setIsFilterModalOpen', false)
                }
            },
        },

        mounted() {
            this.prefillSearchValue()
        },
    }
</script>
